/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo(
    $input: CreateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    createUserInfo(input: $input, condition: $condition) {
      id
      scraping
      trial
      email
      customerId
      stripeAccount
      stripeParentAccount
      createdAt
      updatedAt
      profile {
        id
        name
        phone
        address
        createdAt
        updatedAt
      }
      order {
        items {
          id
          userId
          amount
          metadata
          createdAt
          updatedAt
        }
        nextToken
      }
      shop {
        items {
          id
          userId
          shopId
          createdAt
          updatedAt
          shop {
            id
            name
            domain
            spider
            link
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      buyma {
        items {
          id
          userId
          kaiinId
          buyma
          accessCode
          endedAt
          approved
          subAccount
          createdAt
          updatedAt
        }
        nextToken
      }
      conf {
        id
        scraping
        buymanager
        image
        base
        createdAt
        updatedAt
      }
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo(
    $input: UpdateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    updateUserInfo(input: $input, condition: $condition) {
      id
      scraping
      trial
      email
      customerId
      stripeAccount
      stripeParentAccount
      createdAt
      updatedAt
      profile {
        id
        name
        phone
        address
        createdAt
        updatedAt
      }
      order {
        items {
          id
          userId
          amount
          metadata
          createdAt
          updatedAt
        }
        nextToken
      }
      shop {
        items {
          id
          userId
          shopId
          createdAt
          updatedAt
          shop {
            id
            name
            domain
            spider
            link
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      buyma {
        items {
          id
          userId
          kaiinId
          buyma
          accessCode
          endedAt
          approved
          subAccount
          createdAt
          updatedAt
        }
        nextToken
      }
      conf {
        id
        scraping
        buymanager
        image
        base
        createdAt
        updatedAt
      }
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo(
    $input: DeleteUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    deleteUserInfo(input: $input, condition: $condition) {
      id
      scraping
      trial
      email
      customerId
      stripeAccount
      stripeParentAccount
      createdAt
      updatedAt
      profile {
        id
        name
        phone
        address
        createdAt
        updatedAt
      }
      order {
        items {
          id
          userId
          amount
          metadata
          createdAt
          updatedAt
        }
        nextToken
      }
      shop {
        items {
          id
          userId
          shopId
          createdAt
          updatedAt
          shop {
            id
            name
            domain
            spider
            link
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      buyma {
        items {
          id
          userId
          kaiinId
          buyma
          accessCode
          endedAt
          approved
          subAccount
          createdAt
          updatedAt
        }
        nextToken
      }
      conf {
        id
        scraping
        buymanager
        image
        base
        createdAt
        updatedAt
      }
    }
  }
`;
export const createProfile = /* GraphQL */ `
  mutation CreateProfile(
    $input: CreateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    createProfile(input: $input, condition: $condition) {
      id
      name
      phone
      address
      createdAt
      updatedAt
    }
  }
`;
export const updateProfile = /* GraphQL */ `
  mutation UpdateProfile(
    $input: UpdateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    updateProfile(input: $input, condition: $condition) {
      id
      name
      phone
      address
      createdAt
      updatedAt
    }
  }
`;
export const deleteProfile = /* GraphQL */ `
  mutation DeleteProfile(
    $input: DeleteProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    deleteProfile(input: $input, condition: $condition) {
      id
      name
      phone
      address
      createdAt
      updatedAt
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      userId
      amount
      metadata
      createdAt
      updatedAt
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      userId
      amount
      metadata
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      userId
      amount
      metadata
      createdAt
      updatedAt
    }
  }
`;
export const createUserShop = /* GraphQL */ `
  mutation CreateUserShop(
    $input: CreateUserShopInput!
    $condition: ModelUserShopConditionInput
  ) {
    createUserShop(input: $input, condition: $condition) {
      id
      userId
      shopId
      createdAt
      updatedAt
      shop {
        id
        name
        domain
        spider
        link
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const updateUserShop = /* GraphQL */ `
  mutation UpdateUserShop(
    $input: UpdateUserShopInput!
    $condition: ModelUserShopConditionInput
  ) {
    updateUserShop(input: $input, condition: $condition) {
      id
      userId
      shopId
      createdAt
      updatedAt
      shop {
        id
        name
        domain
        spider
        link
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const deleteUserShop = /* GraphQL */ `
  mutation DeleteUserShop(
    $input: DeleteUserShopInput!
    $condition: ModelUserShopConditionInput
  ) {
    deleteUserShop(input: $input, condition: $condition) {
      id
      userId
      shopId
      createdAt
      updatedAt
      shop {
        id
        name
        domain
        spider
        link
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const createUserBuyma = /* GraphQL */ `
  mutation CreateUserBuyma(
    $input: CreateUserBuymaInput!
    $condition: ModelUserBuymaConditionInput
  ) {
    createUserBuyma(input: $input, condition: $condition) {
      id
      userId
      kaiinId
      buyma
      accessCode
      endedAt
      approved
      subAccount
      createdAt
      updatedAt
    }
  }
`;
export const updateUserBuyma = /* GraphQL */ `
  mutation UpdateUserBuyma(
    $input: UpdateUserBuymaInput!
    $condition: ModelUserBuymaConditionInput
  ) {
    updateUserBuyma(input: $input, condition: $condition) {
      id
      userId
      kaiinId
      buyma
      accessCode
      endedAt
      approved
      subAccount
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserBuyma = /* GraphQL */ `
  mutation DeleteUserBuyma(
    $input: DeleteUserBuymaInput!
    $condition: ModelUserBuymaConditionInput
  ) {
    deleteUserBuyma(input: $input, condition: $condition) {
      id
      userId
      kaiinId
      buyma
      accessCode
      endedAt
      approved
      subAccount
      createdAt
      updatedAt
    }
  }
`;
export const createUserConf = /* GraphQL */ `
  mutation CreateUserConf(
    $input: CreateUserConfInput!
    $condition: ModelUserConfConditionInput
  ) {
    createUserConf(input: $input, condition: $condition) {
      id
      scraping
      buymanager
      image
      base
      createdAt
      updatedAt
    }
  }
`;
export const updateUserConf = /* GraphQL */ `
  mutation UpdateUserConf(
    $input: UpdateUserConfInput!
    $condition: ModelUserConfConditionInput
  ) {
    updateUserConf(input: $input, condition: $condition) {
      id
      scraping
      buymanager
      image
      base
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserConf = /* GraphQL */ `
  mutation DeleteUserConf(
    $input: DeleteUserConfInput!
    $condition: ModelUserConfConditionInput
  ) {
    deleteUserConf(input: $input, condition: $condition) {
      id
      scraping
      buymanager
      image
      base
      createdAt
      updatedAt
    }
  }
`;
export const createShop = /* GraphQL */ `
  mutation CreateShop(
    $input: CreateShopInput!
    $condition: ModelShopConditionInput
  ) {
    createShop(input: $input, condition: $condition) {
      id
      name
      domain
      spider
      link
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateShop = /* GraphQL */ `
  mutation UpdateShop(
    $input: UpdateShopInput!
    $condition: ModelShopConditionInput
  ) {
    updateShop(input: $input, condition: $condition) {
      id
      name
      domain
      spider
      link
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteShop = /* GraphQL */ `
  mutation DeleteShop(
    $input: DeleteShopInput!
    $condition: ModelShopConditionInput
  ) {
    deleteShop(input: $input, condition: $condition) {
      id
      name
      domain
      spider
      link
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBrand = /* GraphQL */ `
  mutation CreateBrand(
    $input: CreateBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    createBrand(input: $input, condition: $condition) {
      id
      brand
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBrand = /* GraphQL */ `
  mutation UpdateBrand(
    $input: UpdateBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    updateBrand(input: $input, condition: $condition) {
      id
      brand
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBrand = /* GraphQL */ `
  mutation DeleteBrand(
    $input: DeleteBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    deleteBrand(input: $input, condition: $condition) {
      id
      brand
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      name
      sex
      important
      normal
      japanese
      foreign
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      name
      sex
      important
      normal
      japanese
      foreign
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      name
      sex
      important
      normal
      japanese
      foreign
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createColor = /* GraphQL */ `
  mutation CreateColor(
    $input: CreateColorInput!
    $condition: ModelColorConditionInput
  ) {
    createColor(input: $input, condition: $condition) {
      id
      name
      key
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateColor = /* GraphQL */ `
  mutation UpdateColor(
    $input: UpdateColorInput!
    $condition: ModelColorConditionInput
  ) {
    updateColor(input: $input, condition: $condition) {
      id
      name
      key
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteColor = /* GraphQL */ `
  mutation DeleteColor(
    $input: DeleteColorInput!
    $condition: ModelColorConditionInput
  ) {
    deleteColor(input: $input, condition: $condition) {
      id
      name
      key
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createTranslateApi = /* GraphQL */ `
  mutation CreateTranslateApi(
    $input: CreateTranslateApiInput!
    $condition: ModelTranslateApiConditionInput
  ) {
    createTranslateApi(input: $input, condition: $condition) {
      id
      translate
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateTranslateApi = /* GraphQL */ `
  mutation UpdateTranslateApi(
    $input: UpdateTranslateApiInput!
    $condition: ModelTranslateApiConditionInput
  ) {
    updateTranslateApi(input: $input, condition: $condition) {
      id
      translate
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteTranslateApi = /* GraphQL */ `
  mutation DeleteTranslateApi(
    $input: DeleteTranslateApiInput!
    $condition: ModelTranslateApiConditionInput
  ) {
    deleteTranslateApi(input: $input, condition: $condition) {
      id
      translate
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createExhibition = /* GraphQL */ `
  mutation CreateExhibition(
    $input: CreateExhibitionInput!
    $condition: ModelExhibitionConditionInput
  ) {
    createExhibition(input: $input, condition: $condition) {
      id
      kaiinId
      url
      imgFolder
      size
      currency
      vatoff
      deliPrice
      profit
      duty
      vipLate
      noCurPrice
      sellPrice
      syuppin
      change
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateExhibition = /* GraphQL */ `
  mutation UpdateExhibition(
    $input: UpdateExhibitionInput!
    $condition: ModelExhibitionConditionInput
  ) {
    updateExhibition(input: $input, condition: $condition) {
      id
      kaiinId
      url
      imgFolder
      size
      currency
      vatoff
      deliPrice
      profit
      duty
      vipLate
      noCurPrice
      sellPrice
      syuppin
      change
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteExhibition = /* GraphQL */ `
  mutation DeleteExhibition(
    $input: DeleteExhibitionInput!
    $condition: ModelExhibitionConditionInput
  ) {
    deleteExhibition(input: $input, condition: $condition) {
      id
      kaiinId
      url
      imgFolder
      size
      currency
      vatoff
      deliPrice
      profit
      duty
      vipLate
      noCurPrice
      sellPrice
      syuppin
      change
      createdAt
      updatedAt
      owner
    }
  }
`;
